export default __webpack_public_path__ + "static/modal-board-a38b26f8e576ceaa5f4e63f0157ddc4f.jpg";